export const booking_flights = {
  booking_flights_search_refresh_click: {
    category: "Booking - Flights",
    action: "User clicks to refresh flight search results",
    label: "booking-flights-refresh-click",
  },
  booking_flights_details_cancel_click: {
    category: "Booking Flights",
    action: "User cancels flight details view",
    label: "booking-flights-details-cancel-click",
  },

  booking_flights_preferences_click: {
    category: "Booking flights interaction",
    action: "User clicks on flight preferences",
    label: "booking-form-flights-pref-click",
  },
  booking_flights_travelers_click: {
    category: "Booking flights interaction",
    action: "User clicks on travelers section",
    label: "booking-form-flights-traveler-click",
  },
  booking_flights_route_class_click: {
    category: "Booking flights interaction",
    action: "User clicks on route section",
    label: "booking-form-flights-route-open-click",
  },
  booking_form_flights_class_open_click: {
    category: "Booking Form – Flights",
    action: "User opens flight class selection",
    label: "booking-form-flights-class-open-click",
  },
  booking_form_flights_route_close_click: {
    category: "Booking Form – Flights",
    action: "User closes flight route selection",
    label: "booking-form-flights-route-close-click",
  },
  booking_form_flights_class_close_click: {
    category: "Booking Form – Flights",
    action: "User closes flight class selection",
    label: "booking-form-flights-class-close-click",
  },

  booking_flights_route_from_click: {
    category: "Booking flights interaction",
    action: "User clicks on From field",
    label: "booking-form-flights-origin-click",
  },
  booking_flights_route_to_click: {
    category: "Booking flights interaction",
    action: "User clicks on To field",
    label: "booking-form-flights-dest-click",
  },
  booking_form_flights_origin_clear: {
    category: "Booking Form – Flights",
    action: "User clears flight origin input",
    label: "booking-form-flights-origin-clear",
  },
  booking_form_flights_origin_option_click: {
    category: "Booking Form – Flights",
    action: "User selects a flight origin option",
    label: "booking-form-flights-origin-option-click",
  },
  booking_form_flights_switch_dest_click: {
    category: "Booking Form – Flights",
    action: "User switches flight origin and destination",
    label: "booking-form-flights-switch-dest-click",
  },
  booking_form_flights_dest_clear: {
    category: "Booking Form – Flights",
    action: "User clears flight destination input",
    label: "booking-form-flights-dest-clear",
  },
  booking_form_multi_city_rmv_dest_click: {
    category: "Booking Form – Flights",
    action: "User removes a destination in multi-city booking form",
    label: "booking-form-multi-city-rmv-dest-click",
  },
  booking_form_flights_dest_option_click: {
    category: "Booking Form – Flights",
    action: "User selects a flight destination option",
    label: "booking-form-flights-dest-option-click",
  },

  booking_departur_date_click: {
    category: "Booking flights interaction",
    action: "User clicks on departure date",
    label: "booking-form-flights-dep-date-click",
  },
  booking_return_date_click: {
    category: "Booking flights interaction",
    action: "User clicks on return date",
    label: "booking-form-flights-return-date-click",
  },
  booking_flights_preferences_refundable_click: {
    category: "Booking flights preferences",
    action: "User selects refundable option",
    label: "flights-pref-flexibility-option-click",
  },
  booking_flights_preferences_connections_click: {
    category: "Booking flights preferences",
    action: "User selects connections option",
    label: "flights-pref-connections-option-click",
  },
  booking_flights_preferences_preferred_airlines: {
    category: "Booking flights preferences",
    action: "User selects preferred airlines",
    label: "flights-pref-pref-airlines-click",
  },
  flights_pref_pref_airlines_option_click: {
    category: "Flights Preferences",
    action: "User selects preferred airline option",
    label: "flights-pref-pref-airlines-option-click",
  },
  flights_pref_pref_airlines_rmv_click: {
    category: "Flights Preferences",
    action: "User removes preferred airline",
    label: "flights-pref-pref-airlines-rmv-click",
  },
  flights_pref_dep_times_clear_click: {
    category: "Flights Preferences",
    action: "User clears departure time preferences",
    label: "flights-pref-dep-times-clear-click",
  },
  flights_pref_dep_times_save_click: {
    category: "Flights Preferences",
    action: "User saves departure time preferences",
    label: "flights-pref-dep-times-save-click",
  },
  flights_pref_dep_times_cancel_click: {
    category: "Flights Preferences",
    action: "User cancels departure time preferences",
    label: "flights-pref-dep-times-cancel-click",
  },

  booking_flights_preferences_departure_times_click: {
    category: "Booking flights preferences",
    action: "User clicks on departure times option",
    label: "flights-pref-dep-times-click",
  },
  booking_flights_preferences_close: {
    category: "Booking flights preferences",
    action: "User clicks close in preferences modal",
    label: "flights-pref-close-click",
  },
  booking_flights_pref_click: {
    category: "Booking Flights",
    action: "User clicks flight preferences",
    label: "booking-flights-pref-click",
  },

  booking_flights_preferences_done: {
    category: "Booking flights preferences",
    action: "User clicks Done in preferences modal",
    label: "flights-pref-save-click",
  },
  booking_flights_travelers_adults_add: {
    category: "Booking flights travelers",
    action: "User adds an adult traveler",
    label: "booking-form-flights-traveler-adult-add",
  },
  booking_flights_travelers_adults_remove: {
    category: "Booking flights travelers",
    action: "User removes an adult traveler",
    label: "booking-form-flights-traveler-adult-rmv",
  },
  booking_flights_travelers_children_add: {
    category: "Booking flights travelers",
    action: "User adds a child traveler",
    label: "booking-form-flights-traveler-child-add",
  },
  booking_flights_travelers_children_remove: {
    category: "Booking flights travelers",
    action: "User removes a child traveler",
    label: "booking-form-flights-traveler-child-rmv",
  },
  booking_flights_travelers_infants_in_seat_add: {
    category: "Booking flights travelers",
    action: "User adds an infant (in seat)",
    label: "booking-form-flights-traveler-infant-add",
  },
  booking_flights_travelers_infants_in_seat_remove: {
    category: "Booking flights travelers",
    action: "User removes an infant (in seat)",
    label: "booking-form-flights-traveler-infant-rmv",
  },
  booking_flights_travelers_infants_on_lap_add: {
    category: "Booking flights travelers",
    action: "User adds an infant (on lap)",
    label: "booking-form-flights-traveler-infant-add",
  },
  booking_flights_travelers_infants_on_lap_remove: {
    category: "Booking flights travelers",
    action: "User removes an infant (on lap)",
    label: "booking-form-flights-traveler-infant-rmv",
  },
  booking_flights_travelers_done_click: {
    category: "Booking flights travelers",
    action: "User clicks Done in travelers modal",
    label: "booking-form-flights-traveler-done-click",
  },
  booking_form_flights_traveler_cncl_click: {
    category: "Booking Form – Flights",
    action: "User cancels traveler selection in flights booking form",
    label: "booking-form-flights-traveler-cncl-click",
  },
  booking_flights_route_and_class_route_selected: {
    category: "Booking flights route",
    action: "User selects route option",
    label: "booking-form-flights-route-option-click",
  },
  booking_flights_route_and_class_class_selected: {
    category: "Booking flights route",
    action: "User selects route option",
    label: "booking-form-flights-class-option-click",
  },
  booking_flights_route_and_class_done: {
    category: "Booking flights route and class",
    action: "User clicks Done in route/class modal",
    label: "booking-flights-route-and-class-done",
  },

  booking_flights_baggage_fare_rules: {
    category: "Booking flights",
    action: "User views baggage & fare rules",
    label: "flights-bag-rules-click",
  },
  booking_flights_baggage_fare_rules_close: {
    category: "Booking flights",
    action: "User closes baggage & fare rules",
    label: "flights-bag-rules-close-click",
  },
  review_cart_flights_bag_rules_cls_click: {
    category: "Review Cart – Flights",
    action: "User closes baggage rules in flight review cart",
    label: "review-cart-flights-bag-rules-cls-click",
  },
  booking_flights_select_fares_cncl_click: {
    category: "Booking flights",
    action: "User cancels select fares modal",
    label: "booking-flights-select-fares-cncl-click",
  },

  booking_flights_select_fares: {
    category: "Booking flights",
    action: "User opens select fares modal",
    label: "booking-flights-select-fares-click",
  },
  selectFlights: {
    category: "Booking flights",
    action: "User opens select fares modal",
    label: "selectFlights",
  },
  booking_flights_select_fares_close: {
    category: "Booking flights",
    action: "User closes select fares modal",
    label: "booking-flights-select-fares-close-click",
  },
};
